import $ from "jquery";

$(function () {
	let scrollTo = $(".aka-block-form");
	let btn = $(".btn-signUp");

	btn.on("click", function (e) {
		e.preventDefault();
		$("html,body").scrollTop(scrollTo.offset().top);
	});
});
